import SectionListingsCategory from './SectionListingsCategory';
export default SectionListingsCategory;
